<template>
  <div>
    <div class="app-head" style="position: fixed;top: 0;z-index: 99;min-width: 500px">
      <div class="app-head-inner">
        <router-link :to="{name: 'index'}" class="head-logo">
          <img src="./assets/logo.png">
        </router-link>
        <div class="wrap">
          <nav id="nav">
            <!--            <div class="logo">-->
            <!--              <a href="#"></a>-->
            <!--            </div>-->
            <ul class="nav">
              <li class="nav-item ">
                <a>
                  <span :class="pageNum==='0'?'active':''" @click="gotoIndex">首页</span>
                </a>
              </li>
              <li class="nav-item">
                <a>
                  <span :class="pageNum==='1'?'active':''" @click="gotoTechnology">技术实力</span>
                </a>
              </li>
              <li class="nav-item">
                <a>
                  <span :class="pageNum==='2'?'active':''" @click="gotoPartners">合作机构</span>
                </a>
              </li>
              <li class="nav-item">
                <a>
                  <span :class="pageNum==='3'?'active':''" @click="gotoAbout">关于我们</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <!--        <div class="head-nav">-->
        <!--          <ul class="nav-list">-->
        <!--            <li @click="showDialog('isShowLogin')">登录</li>-->
        <!--            <li class="nav-pile">|</li>-->
        <!--            <li @click="showDialog('isShowReg')">注册1</li>-->
        <!--            <li class="nav-pile">|</li>-->
        <!--            <li @click="showDialog('isShowAbout')">关于1</li>-->
        <!--          </ul>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="container" style="margin-top: 92px">
      <!--      <keep-alive>-->
      <router-view :key="$route.name"></router-view>
      <!--      </keep-alive>-->
    </div>
    <div class="app-foot">
      <img src="./assets/logo.png" style="width: 264px;">
      <p style="margin-top: 18px;height: 40px">
        <!-- <img src="./assets/logo01.png" style="width: 20px;margin-bottom:-5px"> -->
        <!-- <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202010771" rel="noreferrer" target="_blank">京公网安备11010202010771</a> -->
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank"  >京ICP备2025156377号-2</a>
      </p>
    </div>

  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  data() {
    return {
      pageNum: '0'
    }
  },
  watch: {
    $route(to, from) {
      this.styleSelect()
    }
  },
  created() {
    this.styleSelect()
  },
  methods: {
    styleSelect() {
      const path = this.$route.path
      switch (path) {
        case'/':
          this.pageNum = '0'
          break
        case'/technology':
          this.pageNum = '1'
          break
        case'/partners':
          this.pageNum = '2'
          break
        case'/about':
          this.pageNum = '3'
          break
      }

    },
    gotoIndex() {
      this.$router.push({path: '/'})
      this.pageNum = '0'
    },
    gotoTechnology() {
      this.$router.push({path: '/technology'})
      this.pageNum = '1'
    },
    gotoPartners() {
      this.$router.push({path: '/partners'})
      this.pageNum = '2'
    },
    gotoAbout() {
      this.$router.push({path: '/about'})
      this.pageNum = '3'
    }

  }
}
</script>

<style scoped>
header {
  position: relative;
  z-index: 9999;
  border-bottom: 2px solid #119f0f;
  height: 100px;
  box-sizing: border-box;
}

.wrap {
  width: 1200px;
  margin: 0 auto;
}

#nav {
  display: flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.logo {
  width: 100px;
  overflow: hidden;
}

li.nav-item {
  flex: 1;
}

li.nav-item > a {
  display: block;
  text-align: center;
  line-height: 90px;
  font-weight: 800;
  font-size: 18px;
  position: relative;
  cursor: default;
}

ul.nav {
  display: inline-flex;
  flex: 1;
  padding-left: 50px;
}

/*菜单边框 start*/
.nav a span {
  padding: 4px 32px;
  line-height: 1em;
  background-color: transparent;
  border-radius: 10px;
  transition: all .4s;
  color: #909090;
  cursor: pointer;
}

.nav span:hover {
  color: #FFD900;
  background-color: #4C4C4C
}

/*菜单边框 end*/

/*当前选中菜单 样式 start*/
/*选中tab页下方线*/
li.nav-item > a > span.active::before {
  display: inline;
  content: '';
  left: 50%;
  bottom: 17%;
  transform: translateX(-50%);
  border-width: 2px 50px 2px 10px;
  border-style: solid;
  border-color: #4C4C4C #4C4C4C #4C4C4C #4C4C4C;
  position: absolute;
}

/*选中tab页文字样式*/
.nav a span.active {
  padding: 4px 32px;
  line-height: 1em;
  border-radius: 10px;
  transition: all .4s;
  cursor: pointer;
  font-size: 18px;
  color: #FFD900;
  background-color: #4C4C4C
}

/*当前选中菜单 样式 end*/

/*下方线*/
li.nav-item > a > span::before {
  display: none;
  content: '';
  left: 50%;
  bottom: 17%;
  transform: translateX(-50%);
  border-width: 2px 50px 2px 10px;
  border-style: solid;
  border-color: #4C4C4C #4C4C4C #4C4C4C #4C4C4C;
  position: absolute;
}

/*鼠标移入*/
li.nav-item > a > span:hover::before {
  display: inline;
}

</style>


<style>
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
@font-face {
  font-family: 'CustomFont';
  src: url('./assets/fonts/1.ttf');
}
@font-face {
  font-family: 'heavy';
  src: url('./assets/fonts/heavy.ttf');
}
view {
  font-family: 'CustomFont';
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

body {
  background: #f0f2f5;
  /*font-family: "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Hiragino Sans GB W3", "Microsoft YaHei UI", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;*/
  font-family: 'CustomFont';
  font-size: 14px;
  color: #444;
}

.app-head {
  background: #FFFFFF;
  color: #b2b2b2;
  height: 90px;
  line-height: 90px;
  width: 100%;
  min-width: 1000px;
}

.app-head-inner {
  /*width: 1920px;*/
  margin: 0 auto;
}

.head-logo {
  float: left;
  margin-top: 9px;
}

.head-logo img {
  width: 256px;
  margin-left: 108px;
}

.head-nav {
  float: right;
}

.head-nav ul {
  overflow: hidden;
}

/*.head-nav li {*/
/*  cursor: pointer;*/
/*  float: left;*/
/*}*/
.nav-pile {
  padding: 0 10px;
}

.app-foot {
  text-align: center;
  height: 50px;
  width: 100%;
  line-height: 20px;
  background: #F2F2F2;
  clear: both;
  margin-top: 70px;
}

.container {
  width: 100%;
  margin: 0 auto;
}

.hr {
  height: 1px;
  width: 100%;
  background: #ddd;
}

.button {
  background: #4fc08d;
  color: #fff;
  display: inline-block;
  padding: 10px 20px;
  /*cursor: pointer;*/
  border-radius: 5px;
}

.button:hover {
  background: #4fc08d;
}

.g-form {

}

.g-form-line {
  padding: 15px 0;
}

.g-form-label {
  width: 100px;
  font-size: 16px;
  display: inline-block;
}

.g-form-input {
  display: inline-block;
}

.g-form-input input {
  height: 30px;
  width: 200px;
  line-height: 30px;
  vertical-align: middle;
  padding: 0 10px;
  border: 1px solid #ccc;
}

.g-form-btn {
  padding-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue